import { apiRequest } from "./ApiRequest";

import { ApiResponse } from "../api/types/ApiResponse";
import { BetVm } from "../types/BetVm";
import { DataAttributes } from "../types/DataAttributes";

export const apiService = async (dataAttr: DataAttributes): Promise<BetVm | null> => {
    try {
        // Fetch data from API
        const apiResponse = await apiRequest<ApiResponse>(dataAttr.apiUrl);
        
        // Create BetVm instance
        const betVm = new BetVm(apiResponse, dataAttr);
        
        return betVm;
    } catch (error) {
        // Handle errors
        console.error("Failed to fetch data:", error);
        return null;
    }
};
